import React from 'react';

import {fetchEventQuestionAnswers} from '../../data/fetch';
import {useStoredDataChanged} from './useStoredDataChanged';
import Loader from './Loader';

const LoadQAAnswers = ({eventId, questionId, children}) => {
    useStoredDataChanged();
    return (
        <Loader
            skipSpinner={state => !!state.events[eventId]?.questions.indexed[questionId]?.answers?.length}
            promises={[fetchEventQuestionAnswers(eventId, questionId)]}>
            {children}
        </Loader>
    );
};

export default LoadQAAnswers;
